import gql from 'graphql-tag'

export const getUserForAddPaymentQuery = gql`
  query GetUserProfile {
    getUserProfile {
      id
      isAdmin
      client {
        id
        name
        subscription {
          id
        }
      }
    }
  }
`
